// import {
//     DA_CartData,
//     DA_CartDataApi,
//     DA_CartLineApi,
// } from "@danishagro/shared/src/interfaces/cartData.interface";
import {
    BasketArgs,
    CompleteOrder,
    DA_BasketData,
    DA_BasketDataApi,
    DA_BasketLineApi,
    DA_BasketOrderLine,
} from "@danishagro/shared/src/interfaces/basket.interface";
// import { DA_CartOrderLine } from "@danishagro/shared/src/interfaces/cartOrderLine.interface";
import { DA_B2bImageProps } from "@danishagro/shared/src/interfaces/b2bImageProps.interface";
import { getB2bImage } from "@danishagro/shared/src/helpers/getB2bImage.helper";
// import { DA_CartPriceData } from "@danishagro/shared/src/interfaces/price.interface";
// import { da } from "date-fns/locale";

export const mapToBasketLineApi = (args: BasketArgs): DA_BasketLineApi => {
    return {
        id: null,
        productId: args.productId,
        quantity: args.quantity,
        name: null,
        description: null,
        imageUrl: null,
        data: null,
    };
};

// export const mapToCartData = (data: DA_CartDataApi): DA_CartData => {
//     const addressData = {
//         ...data.shippingDetails?.shippingAddress,
//         id: data.shippingDetails?.shippingAddress.id,
//         countryCode: data.shippingDetails?.shippingAddress.country,
//         companyName: data.shippingDetails?.shippingAddress.name,
//     };

//     return {
//         id: data.id,
//         orderLines: data.lines?.map((line) => mapToCartOrderLine(line)),
//         state: data.basketStatus,
//         secret: data.secret,
//         customerNumber: data.customerNumber,
//         showCropProtectionDeliveryMode: data.data?.showCropProtectionDeliveryMode,
//         cropProtectionDeliveryWeight: data.data?.cropProtectionDeliveryWeight,
//         disableCropProtectionDelivery: data.data?.disableCropProtectionDelivery,
//         combinedDelivery: data.data?.combinedDelivery,
//         cropProtectionDeliveryMode: data.data?.cropProtectionDeliveryMode,
//         unit: data.data?.unit,
//         lineGrossWeight: data.data?.lineGrossWeight,
//         itemGrossWeight: data.data?.itemGrossWeight,
//         isAdditionalProduct: data.data?.isAdditionalProduct,

//         customerDetails: {
//             ...addressData,
//             email: "[NOT IMPLEMENTED]",
//             phone: "[NOT IMPLEMENTED]",
//             cvr: "[NOT IMPLEMENTED]",
//         },
//         shippingDetails: {
//             ...addressData,
//             locationId: data.shippingDetails?.shippingAddress.locationId,
//         },
//         invoiceDetails: {
//             invoiceAddress: data.invoiceDetails?.invoiceAddress,
//         },

//         // TODO: get these values from API later and map them correctly
//         farmInTimeReferenceId: null,
//         farmInTimeDriverMessage: null,
//         isCompleted: false,
//         isExpressDelivery: false,
//         transactionId: null,
//     };
// };

const mapToBasketOrderLine = (line: DA_BasketLineApi): DA_BasketOrderLine => {
    const { id, productId, productNumber, productVariantId, quantity, url } = line;

    const img: DA_B2bImageProps = {
        url: line.imageUrl,
        width: 85,
        height: 85,
    };
    const sizedImage = getB2bImage(img, {
        maxWidth: 85,
        maxHeight: 85,
    });

    return {
        id,
        productId,
        productName: line.name,
        productNumber,
        productVariantId,
        productEntityId: line.productEntityId,
        quantity,
        url,

        image: sizedImage,
        imageUrl: line.imageUrl,
        price: line?.data?.price,
        unit: line.data?.unit,
        brandName: line.data?.brandName,
        hidePrice: line.data?.hidePrice,

        // TODO: Clean up obsolete properties
        productVariantName: "",
        allowCropProtectionDelivery: false,
        allowExpressDelivery: false,
        driverMessage: "",
        foVariantId: "",
        lineGrossWeight: 0,
        itemGrossWeight: 0,
    };
};

export const mapToBasketData = (data: DA_BasketDataApi): DA_BasketData => {
    return {
        id: data.id,
        channelId: data.channelId,
        shortId: data.shortId,
        secret: data.secret,
        state: data.basketStatus,
        createdDate: data.createdDate,
        updatedDate: data.updatedDate,
        orderLines: data.lines?.map((line) => mapToBasketOrderLine(line)),
        prices: data.data?.prices,
        customerNumber: data.customerNumber || null,

        customerDetails: {
            ...data.customerDetails,
            cvr: data.customerDetails?.cvr || "[NOT PROVIDED]",
            email: data.customerDetails?.email || "[NOT PROVIDED]",
            phone: data.customerDetails?.phone || "[NOT PROVIDED]",
        },

        shippingDetails: {
            id: data.shippingDetails?.shippingAddress?.id || null,
            address: data.shippingDetails?.shippingAddress?.address || "",
            streetName: data.shippingDetails?.shippingAddress?.streetName || "",
            streetNumber: data.shippingDetails?.shippingAddress?.streetNumber || "",
            city: data.shippingDetails?.shippingAddress?.city || "",
            countryCode: data.shippingDetails?.shippingAddress?.country || "",
            name: data.shippingDetails?.shippingAddress?.name || "",
            zipCode: data.shippingDetails?.shippingAddress?.zipCode || "",
            companyName: data.shippingDetails?.shippingAddress?.companyName || "",
            locationId: data.shippingDetails?.shippingAddress?.locationId || "",
        },
        invoiceDetails: data.invoiceDetails || null,

        // TODO: Clean up obsolete properties
        isCompleted: data.isCompleted || false,
        showCropProtectionDeliveryMode: data.data?.showCropProtectionDeliveryMode,
        deliveryMethod: data.data?.deliveryMethod,
    };
};

export const mapToOrder = (data: DA_BasketDataApi): CompleteOrder => {
    return {
        ...mapToBasketData(data),
        completedDate: data.updatedDate,
        deliveryMethod: data.data?.deliveryMethod,
        paymentMethod: data.data?.paymentMethod,
        comment: data.data?.checkoutComment,
        servicePoint: data.data?.servicePoint,
    };
};
